<template>
  <div>
    <SingleBtnDialog
      v-if='showSingleBtnDialogFlag'
      :messageType='singleBtnMsgType'
      :onClickConfirmBtn='onClickConfirmBtn'/>
  </div>
</template>

<script>
import SingleBtnDialog from '@/components/Dialog/SingleBtnDialog.vue'
export default {
  components: {
    SingleBtnDialog
  },
  data () {
    return {
      showSingleBtnDialogFlag: true, // single btn Dialog show flag
      singleBtnMsgType: 14 // single Btn Dialog의 message type
    }
  },
  mounted () {
    localStorage.setItem('isDuplicatdLogin', 'true')
  },
  methods: {
    onClickConfirmBtn () {
      // this.appUpdateUserInfo(localStorage.getItem('appUserCode'), '', true)
      // localStorage.removeItem('Authorization')
      localStorage.removeItem('encPasswd')
      localStorage.removeItem('appUserCode')
      this.$router.replace({ name: 'AppOrderSelect' })
    }
  }
}
</script>

<style scoped>
</style>
